import React, {useState} from "react"
import { StaticQuery, graphql, Link, withPrefix } from "gatsby"
import "./layout.scss"

import { exclamations } from "../components/utils"

const navOrder = ["lectures","tutorials","assignments", "help"]

const Nav = (data) => {
  let path = data.location ? data.location.pathname : "";
  return data.group.sort((a,b) =>navOrder.indexOf(a.distinct[0])>navOrder.indexOf(b.distinct[0]) ? 1 : -1)
  .map((item,i) =>
    <div className="subnav" key={i}>
      <b className="subnav-title">{item.distinct[0]}</b>
      <div className="subnav-list">
        {item.edges.map(e => e.node)
          .map((node,i) => <Link className={path.indexOf(node.slug.toLowerCase()) > -1 ? "active": ""}
          key={i} to={`/${item.distinct[0]}/${node.slug.toLowerCase()}`}>
            {node.frontmatter.classNumber ? node.frontmatter.classNumber+") " : ""} {node.frontmatter.title}
          </Link>)}
      </div>
    </div>
  )
}

export default function Layout({children,location}) {
  let [hidden,setHidden] = useState(false);
  return (
    <StaticQuery
      query={graphql`
        query HeadingQuery {
          site {
            siteMetadata {
              title
            }
          }
          posts: allMdx(
            sort: {fields: frontmatter___classNumber}
            filter: {frontmatter: {draft: {ne: true}}}
          ){
              group(field: frontmatter___type) {
                edges {
                  node {
                    id
                    slug
                    frontmatter {
                      classNumber
                      title
                      type
                    }
                  }
                }
                distinct(field: frontmatter___type)
              }
            }
          }
      `}
      render={data => {
        const isHomepage = location.pathname === withPrefix("/")
        return (
          <div id="main" className={hidden ? "hidden":""}>
            <div id="site-title">
              <Link to={withPrefix("/")}>{exclamations(!isHomepage ? "Back To Home" :data.site.siteMetadata.title)}</Link>
            </div>
            <div id="corpse"><img src="/ec.png"></img></div>
            <div id="page">
              <div id="hide-menu" onClick={()=> setHidden(!hidden)}></div>
              <div id="nav">
                <Nav group={data.posts.group} location={location}/>
                <Link style={{display: "none"}} className="nav-link" to="/help">Help</Link>
                <span>qs? email me! <br></br>
                  <a href="mailto:henry@candusen.net">henry@candusen.net</a>
                </span>
              </div>
              <div id="content">{children}</div>
            </div>
          </div>
      )}
    }
    />
  )
}
